module.exports = __webpack_public_path__ + "static/img/img15.5f8b682.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/img15.png
// module id = cKJh
// module chunks = 1